import "../styles/CabHeader.scss";
import useGetUserProfile from "../hooks/useGetUserProfile";
import { f } from "react-router/dist/development/fog-of-war-Ckdfl79L";

const CabHeader = ({ username,  data, isLoading, error  }: any) => {
    
    // const dataHeader = {
    //     "user_callsign": "Позывной",
    //     "team": {
    //       "name": "Тестовая команда",
    //       "avatar_link": "https://media.cybershtab.ru/cybershtab-local-bucket/images/teams/avatars/6d588e0c-6bea-446e-85f1-149df9d8dc8e.jpg",
    //       "slug": "13158-testovaia-komanda"
    //     },
    //     "region_name": "Санкт-Петербург и ЛО",
    //     "user_about": "Обо мне",
    //     "user_main_spec": {
    //       "name": "Снайпер",
    //       "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/users/specialisations/1a3374cb-ffb0-47e4-94cc-fc8c3a6a4c76.jpg"
    //     },
    //     "user_camouflages": [
    //       {
    //         "name": "Ночь",
    //         "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/camouflages/f783f09c-c87b-4965-a499-da7968d7d821.jpg"
    //       },
    //       {
    //         "name": "Темный лес",
    //         "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/camouflages/9b1ca931-2100-4dcb-ad81-02c540726b24.jpg"
    //       }
    //     ],
    //     "user_main_weapon": {
    //       "name": "Моя винтовка",
    //       "type": {
    //         "name": "Винтовка",
    //         "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/weapon/type/8d155f01-738d-4e26-94d7-225270d69643.jpg"
    //       },
    //       "firm_name": "Тестовый производитель"
    //     }
    // }

    return (
        <header className="header">
            <img className="header__background" src={data?.user_banner_link != null ? data?.user_banner_link : '../EmptyProfileSection/bg_empty.png'}></img>
            
            <div className="header__content">
                <div className="header__left">
                    <span className="header__name">{data?.user_callsign}</span>
                    <span className="header__subname">{data?.team?.name}</span>
                </div>
                
                <div className="header__center">
                    <img className="header__logo" src={data?.user_avatar_link != null ? data?.user_avatar_link : '../EmptyProfileSection/ava_empty.png'}></img>
                </div>
        
                <div className="header__right">
                    <span className="header__location">{data?.region_name}</span>
                </div>
            </div>
        </header>
        );
    };
    
    export default CabHeader;